import React from 'react';
import Navbar from '../../components/navbar';
import CRUDColaboradores from '../../components/crudColaboradores';

function VistaDatosColaboradores() {
    return (
        <CRUDColaboradores />
    )
}

export default VistaDatosColaboradores;